import { useEffect, useState } from "react";

const TARGET = new Date("2026-11-01T00:00:00+01:00").getTime();
const pad = (n) => String(n).padStart(2, "0");

export const CountdownBar = () => {
  const [left, setLeft] = useState(() => TARGET - Date.now());
  useEffect(() => { const t = setInterval(() => setLeft(TARGET - Date.now()), 1000); return () => clearInterval(t); }, []);
  if (left <= 0) return null;
  const s = Math.floor(left / 1000);
  const cells = [[Math.floor(s / 86400), "J"], [Math.floor((s % 86400) / 3600), "H"], [Math.floor((s % 3600) / 60), "Min"], [s % 60, "Sec"]];
  return (
    <div className="bg-gradient-to-r from-[#0a0a0a] via-[#1c1710] to-[#0a0a0a] border-y border-[#F3E2B6]/25 text-white py-2 px-4" data-testid="countdown-bar" role="timer" aria-label="Compte à rebours avant le 1er novembre">
      <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1">
        <p className="flex items-center gap-2.5"><span className="text-[9px] sm:text-[10px] tracking-[0.3em] uppercase text-[#F3E2B6]">Bientôt · 1er novembre</span><span className="font-head italic text-base sm:text-lg font-light">Le mois du Black Friday</span></p>
        <div className="flex items-baseline gap-2 sm:gap-3">
          {cells.map(([n, l]) => <span key={l} className="flex items-baseline gap-1"><b className="font-head text-lg sm:text-xl font-light [font-variant-numeric:lining-nums_tabular-nums]" data-testid={`countdown-${l.toLowerCase()}`}>{pad(n)}</b><span className="text-[8px] sm:text-[9px] tracking-[0.2em] uppercase text-[#F3E2B6]/70">{l}</span></span>)}
        </div>
      </div>
    </div>
  );
};
